import { Link, useLocation } from "react-router-dom";
import SignInChooser from "@/components/SignInChooser";

export default function SiteHeader() {
  const loc = useLocation();
  const linkClass = (p) =>
    `ws-label transition-colors ${
      loc.pathname === p ? "text-[#FF5A00]" : "text-[#09090B] hover:text-[#FF5A00]"
    }`;

  return (
    <header className="border-b-2 border-[#09090B] bg-white sticky top-0 z-40">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" data-testid="brand-link" aria-label="WorkSafeStory home" className="flex items-center shrink-0">
          <img
            src="/brand/worksafestory-lockup-light.svg"
            alt="WorkSafeStory"
            data-testid="brand-lockup"
            className="h-8 w-auto"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-8 ml-auto">
          <Link to="/about" data-testid="nav-about" className={linkClass("/about")}>
            About
          </Link>
          <Link to="/submit" data-testid="nav-submit" className={linkClass("/submit")}>
            Share Story
          </Link>
          <Link to="/wall" data-testid="nav-wall" className={linkClass("/wall")}>
            Wall of Safety
          </Link>
        </nav>
        <div className="md:ml-8">
          <SignInChooser />
        </div>
      </div>
    </header>
  );
}
